import { render, staticRenderFns } from "./TradingGroupAlertsReportTemplate.vue?vue&type=template&id=a7d59d24"
import script from "./TradingGroupAlertsReportTemplate.vue?vue&type=script&lang=js"
export * from "./TradingGroupAlertsReportTemplate.vue?vue&type=script&lang=js"
import style0 from "./TradingGroupAlertsReportTemplate.vue?vue&type=style&index=0&id=a7d59d24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports